import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../../components/ui/table';
import { Buildings, MapPin, Stethoscope } from '@phosphor-icons/react';

// --- Place of Service Tab -----------------------------------------------
export const PlaceOfServiceTab = ({ codes }) => (
  <Card className="border-slate-200">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <MapPin size={20} className="text-blue-600" />
        CMS Place of Service Codes
      </CardTitle>
      <CardDescription>Standard codes for Ohio Medicaid professional claims</CardDescription>
    </CardHeader>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-20">Code</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {codes &&
            Object.entries(codes).map(([code, info]) => (
              <TableRow key={code}>
                <TableCell>
                  <span className="font-mono font-semibold text-indigo-700">{code}</span>
                </TableCell>
                <TableCell className="font-medium">{info.name}</TableCell>
                <TableCell className="text-slate-600">{info.description}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

// --- Diagnosis Codes Tab ------------------------------------------------
export const DiagnosisCodesTab = ({ codes }) => (
  <Card className="border-slate-200">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Stethoscope size={20} className="text-emerald-600" />
        Common ICD-10 Diagnosis Codes
      </CardTitle>
      <CardDescription>
        Frequently used diagnosis codes for home health and personal care
      </CardDescription>
    </CardHeader>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-24">Code</TableHead>
            <TableHead>Description</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {codes?.map((dx) => (
            <TableRow key={dx.code}>
              <TableCell>
                <span className="font-mono font-semibold text-emerald-700">{dx.code}</span>
              </TableCell>
              <TableCell>{dx.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

// --- Managed Care Payers Tab --------------------------------------------
export const ManagedCarePayersTab = ({ payers, odmFfsPayerId }) => (
  <Card className="border-slate-200">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Buildings size={20} className="text-purple-600" />
        Ohio Managed Care Plan Payer IDs
      </CardTitle>
      <CardDescription>
        EDI Payer IDs for Ohio Medicaid managed care organizations
      </CardDescription>
    </CardHeader>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Plan</TableHead>
            <TableHead>Payer ID</TableHead>
            <TableHead>Full Name</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {payers &&
            Object.entries(payers).map(([key, info]) => (
              <TableRow key={key}>
                <TableCell className="font-medium">{key}</TableCell>
                <TableCell>
                  <span className="font-mono">{info.payer_id}</span>
                </TableCell>
                <TableCell className="text-slate-600">{info.name}</TableCell>
              </TableRow>
            ))}
          <TableRow>
            <TableCell className="font-medium">ODM Fee-for-Service</TableCell>
            <TableCell>
              <span className="font-mono">{odmFfsPayerId}</span>
            </TableCell>
            <TableCell className="text-slate-600">Ohio Department of Medicaid</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);
